/* eslint-disable no-nested-ternary */
import { Link as RouterLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, Box, Stack, TextField, InputAdornment, Skeleton, IconButton } from '@mui/material';

// hooks
import { collection, getDocs, query } from 'firebase/firestore';
import { db } from '../firebase.config';

// components
import Page from '../components/Page';
// sections

import HomeNavbar from '../layouts/home/HomeNavbar';
import CustomButton from '../components/CustomButton';
import CheckOrg from '../components/CheckOrg';
import Iconify from '../components/Iconify';
import EventList from '../components/home/eventList';
import { hasPermission } from '../utils/functions';
import { UserAuth } from '../context/AuthContext';
import LucideIcon from '../components/LucideIcon';
import CustomTextField from '../components/ui/customTextField';
import useResponsive from '../hooks/useResponsive';

// ---------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  backgroundColor: '#ffff',
  height: '100%',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));


// ----------------------------------------------------------------------

export default function Home() {
  const { user, userData, permissions } = UserAuth();
  const smUp = useResponsive('up', 'sm');
  const [open, setOpen] = useState(false);
  const [type, setType] = useState(1);
  const [eventName, setEventName] = useState();
  const [loading, setLoading] = useState(true);
  const [thereIsEvent, setThereIsEvent] = useState(false);

  const getData = async () => {
    try {
      setLoading(true);
      if (user) {
        console.log(userData)
        const q = query(
          collection(db, `organisations/${userData.idOrg}/events`),
        );

        const querySnapshot = await getDocs(q);
        console.log(querySnapshot.size)
        if (querySnapshot.size > 0) {
          setThereIsEvent(true)
        }
      }
    } catch (error) {
      console.log("Error fetching data: ", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    (async () => {
      getData();
    })();
  }, [user, userData]);



  return (
    <Page title="Home">
      <RootStyle>
        <HomeNavbar onOpenSidebar={() => setOpen(true)} />
        <Container >
          <Stack paddingY={10} spacing={3}>
            <Box>
              <Typography sx={{ textTransform: 'initial' }} variant="h2">{`Bonjour ${userData?.prenom}`}</Typography>
              <Typography variant="h5" sx={{ fontWeight: 500 }}>Bienvenue dans choptonticket</Typography>
            </Box>

            <CheckOrg />

            {
              loading ?
                <Stack pt={2} spacing={2} direction={{ xs: 'column-reverse', sm: 'row' }} useFlexGap flexWrap="wrap" justifyContent='space-between'>
                  <Skeleton height={80} width={'80%'} />
                  <Skeleton height={80} width={'18%'} sx={{ borderRadius: '16px' }} />
                </Stack>
                : thereIsEvent ?
                  <Stack pt={2} spacing={2} direction='row'   alignItems={'center'}>
                    <CustomTextField fullWidth startIcon={<LucideIcon name='Search' />} value={eventName} onChange={(e) => setEventName(e)} placeholder='Rechercher un événement'/>
                    {hasPermission(permissions, "create_event") && (
                      <CustomButton
                        size="large"
                        type='primaire'
                        // buttonText="Créer un événement"
                        buttonText={smUp ? 'Créer un événement' : null}
                        icon={'Plus'}
                        component={RouterLink}
                        to="/bo/new_event"
                      />
                    )}

                  </Stack>
                  : null
            }


            {
              loading ?
                <Stack spacing={1} direction='row' >
                  <Skeleton height={60} width={'5%'} sx={{ borderRadius: '20px' }} />
                  <Skeleton height={60} width={'6%'} sx={{ borderRadius: '20px' }} />
                  <Skeleton height={60} width={'7%'} sx={{ borderRadius: '20px' }} />
                  <Skeleton height={60} width={'5%'} sx={{ borderRadius: '20px' }} />
                </Stack>
                : thereIsEvent ?
                  <Stack direction='row' spacing={1}>
                    <Box onClick={() => setType(0)} sx={type === 0 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
                      :
                      { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1} >
                      <Typography variant='body2'>Tous</Typography>
                    </Box>
                    <Box onClick={() => setType(1)} sx={type === 1 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
                      :
                      { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1} >
                      <Typography variant='body2'>Publié</Typography>
                    </Box>
                    <Box onClick={() => setType(2)} sx={type === 2 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
                      :
                      { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1} >
                      <Typography variant='body2'>Brouillon</Typography>
                    </Box>
                    <Box onClick={() => setType(3)} sx={type === 3 ? { bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }
                      :
                      { bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1} >
                      <Typography variant='body2'>Clos</Typography>
                    </Box>
                  </Stack>
                  : null
            }


            {
              thereIsEvent ?
                <Box>
                  <EventList type={type} eventName={eventName} />
                </Box>
                :
                <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} >
                  <Stack component={RouterLink}
                    to="/bo/new_event" spacing={2} alignItems={'center'} padding={4} sx={{
                      borderRadius: '10px', width: { xs: '100%', sm: '60%' }, cursor: 'pointer', backdropFilter: "blur(8px)", // flou
                      background: "rgba(94, 23, 235, 0.05)", // transparent blanc
                      border: "1px solid rgba(94, 23, 235, 0.06)", // léger contour
                      boxShadow: "0 4px 20px rgba(0,0,0,0.05)", // ombre moderne
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background: "rgba(94, 23, 235, 0.2)",
                        color: 'white',
                        // transform: "scale(1.025)",
                      },
                    }}>
                    <Typography variant="h5" sx={{ fontWeight: 500 }}>Commencer par créer votre premier evenement</Typography>
                    {hasPermission(permissions, "create_event") && (
                      <IconButton component={RouterLink}
                        to="/bo/new_event" sx={{ bgcolor: 'rgba(94, 23, 235, 0.05)' }}>
                        <LucideIcon name='ArrowRight' size={100} />
                      </IconButton>
                    )}
                  </Stack>
                  <Box paddingY={2} sx={{ width: '100%' }}>
                    <Typography variant="h5" sx={{ fontWeight: 500 }}>Pour bien démarrer : les ressources indispensables</Typography>
                    <Stack spacing={2} paddingY={2}>
                      <Stack direction={'row'} spacing={2}>
                        <Box sx={{ padding: 2, borderRadius: '10px', border: '1px solid gainsboro', width: '100%' }}>
                          <Typography>Comment créer votre premier événement (étape par étape)</Typography>
                        </Box>
                        <Box sx={{ padding: 2, borderRadius: '10px', border: '1px solid gainsboro', width: '100%' }}>
                          <Typography>Configurer les billets et les catégories de prix</Typography>
                        </Box>
                      </Stack>
                      <Stack direction={'row'} spacing={2}>
                        <Box sx={{ padding: 2, borderRadius: '10px', border: '1px solid gainsboro', width: '100%' }}>
                          <Typography>Comment personnaliser votre page événement</Typography>
                        </Box>
                        <Box sx={{ padding: 2, borderRadius: '10px', border: '1px solid gainsboro', width: '100%' }}>
                          <Typography>Ajouter et gérer les membres de votre équipe</Typography>
                        </Box>
                      </Stack>
                    </Stack>
                  </Box>
                </Stack>
            }
            <Box paddingY={4} sx={{ width: '100%' }}>
              <Typography variant="h5" sx={{ fontWeight: 500 }}>Centre d'aide</Typography>
              <Stack spacing={2} paddingY={2}>
                <Stack direction={'row'} spacing={2}>
                  <Box sx={{ padding: 2, borderRadius: '10px', border: '1px solid gainsboro', width: '100%' }}>
                    <Typography>Le guide complet du marketing événementiel 2025</Typography>
                  </Box>
                  <Box sx={{ padding: 2, borderRadius: '10px', border: '1px solid gainsboro', width: '100%' }}>
                    <Typography>Le guide complet du marketing événementiel 2025</Typography>
                  </Box>
                  
                </Stack>
              </Stack>
            </Box>

          </Stack>
        </Container>
      </RootStyle>
    </Page>
  );
}
